import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/debt/useDebtQueryKeys.ts
var t = e("debt", {
	summary: (e) => ["summary", e],
	history: (e) => ["history", e],
	collectedFrom: (e) => ["collected-from", e],
	penalty: (e) => ["penalty", e],
	collections: (e) => ["penalty-collections", e]
});
//#endregion
export { t as debtQueryKeys };
